export const CMMS_RECORD_TYPES = [
  'cmms-work-order',
  'cmms-pm',
  'cmms-asset',
  'cmms-item',
  'cmms-stock',
  'cmms-purchase-order',
  'cmms-purchase-requisition',
  'cmms-vendor',
  'cmms-location',
  'cmms-job-plan',
  'cmms-inspection-result',
  'cmms-inventory-usage',
  'cmms-inventory-balance',
] as const
export type CmmsRecordType = (typeof CMMS_RECORD_TYPES)[number]

export const CMMS_NUMBER_FIELDS: Record<CmmsRecordType, string> = {
  'cmms-work-order': 'wonum',
  'cmms-pm': 'pmnum',
  'cmms-asset': 'assetnum',
  'cmms-item': 'itemnum',
  'cmms-stock': 'itemnum',
  'cmms-purchase-order': 'ponum',
  'cmms-purchase-requisition': 'prnum',
  'cmms-vendor': 'company',
  'cmms-location': 'location',
  'cmms-job-plan': 'jpnum',
  'cmms-inspection-result': 'resultnum',
  'cmms-inventory-usage': 'invusenum',
  'cmms-inventory-balance': 'itemnum',
}
